class FaqPageTabs extends HTMLElement {
  connectedCallback() {
    const active = this.querySelector(
      '.faq-page-content__tabs-nav a.is-active, .faq-page-content__tabs-nav a[aria-current="page"]'
    );
    if (!active) return;
    requestAnimationFrame(() => {
      active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' });
    });
  }
}

customElements.define('faq-page-tabs', FaqPageTabs);
